import { Grid, TextField, Checkbox, List } from '@mui/material';

export default function ProductListInfoContainter({ edit = false, productData, detailsProp, scheduled, setScheduled }) {
    /******************
          CONST
      *******************/
    if (!edit)
        return (
            <div className='col-12'>
                <List className='ms-2 col-12' id={"product-device-info"}>
                    {detailsProp.map((field, index) => {
                        if (field.reference !== 'scheduledTimestamp' && field.reference !== 'legalText')
                            return (
                                <Grid item key={index} className='d-flex my-3 align-items-center'>
                                    <span className='me-2 col-4'>{field.title}:</span>
                                    <span>{productData[field.reference]}</span>
                                </Grid>
                            )
                        else
                            return null
                    })}
                </List>
            </div>
        )
}